<template>
  <div class="workpage-right-column">
    <h1>ПРОДУКЦИЯ</h1>

    <div class="b-catalog-main">
      <div v-for="(category, id) in categories" :key="id" class="b-catalog-main__section">
        <div class="b-catalog-main__text">
          <p class="b-catalog-main__section-name">
            <router-link class="b-catalog-main__href" :to="{
                name: category.id === 6 ? 'subCategory' : 'category',
                params: {
                  groupId: category.id === 6 ? 11 : category.id,
                  pGroupId: category.id === 6 ? 6 : undefined,
                },
              }">
              {{category.name}}</router-link
            >
          </p>
          <div class="b-catalog-main__section-text">
            <p>
              Материалы производятся на заводах в Европе и поставляются непосредственно со складов Швейцарии, Германии, Франции, Италии, Польши и других стран Европейского Союза.
            </p>
          </div>
        </div>
        <div
          class="b-catalog-main__img"
          :style="{backgroundImage: `url(${category.fon})`}"
        >
          <router-link class="b-catalog-main__img-href" :to="{
                name: category.id === 6 ? 'subCategory' : 'category',
                params: {
                  groupId: category.id === 6 ? 11 : category.id,
                  pGroupId: category.id === 6 ? 6 : undefined,
                },
              }" />
          <img
            :src="category.img"
            alt=""
            class="b-catalog-main__img-item"
          />
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
        catFon: [
        "/upload/uf/7ed/7ed3bf29be71418024640d6fa2e1cab6.jpg",
        "/upload/uf/e15/e151699f64aeab7b8bb1fbfcb6ad5bea.jpg",
        "/upload/uf/a02/a02eba512a980591f9e8783f360e243f.jpg",
        "/upload/uf/108/1080ab31d1b843de6e9bcb39991ac64e.jpg",
        "/upload/uf/4d6/4d632d11af7261f96ad3939a44e962e0.jpg",
        // "/upload/uf/159/1596b41e7bd58fe62de809f3cf843c2b.jpg",
        "/upload/uf/616/6169beac453101e34ae9f230bcb6c94b.jpg",
        "/upload/uf/bbe/bbed762c3bbdc6d54cca7570e2f56fec.jpg",
        "/upload/uf/cdb/cdb8e0078799b9201199ccb5703648f0.jpg",
        "/upload/uf/08e/2.png",
      ],
      catImgs: [
        "/upload/uf/228/228c26364b6d130a8ed0d9c5c3323c48.png",
        "/upload/uf/08e/08e85b7bfd8bb11cf2ca1ec1feb4e274.png",
        "/upload/uf/8d5/8d5f607049121ba87b7c3bf5d9b68db2.png",
        "/upload/uf/10f/10f1d9d753db874e4db422833018c66c.png",
        "/upload/uf/054/0542cfddf7de65c365ad3008bf217475.png",
        // "/upload/uf/d19/d19e54ea6484220a75a108f8c88b6bc8.png",
        "/upload/uf/a34/a34d5d2e7548635c8d411e0a3aa13729.png",
        "/upload/uf/c71/c712185b0a746f2736a25c8f3c9f2ce2.png",
        "/upload/uf/40a/40a508d1bb3f8b3020dfdeee1baf214b.png",
        "/upload/uf/08e/1.png",
      ],
    };
  },
  computed: {
    categories() {
      let out = {};
      let index = 0;
      for (let [id, category] of Object.entries(this.cat)) {
        out = {
          ...out,
          [category.id]: { ...category, fon: this.catFon[index], img: this.catImgs[index] },
        };
        index++;
      }
      return out;
    },
    ...mapState(["cat", "articles"]),
  },
};
</script>

<style lang="scss" scoped></style>
